import EventBus from '@/event-bus';
import FavoritesProducts from '@/favorites';
import _Singleton from '@/tools/singleton';
import jquery from 'jquery';
import _includes from 'lodash/includes';
import _map from 'lodash/map';
import _toNumber from 'lodash/toNumber';

import options from '@/ui/ui_favorites/default-selectors.json';
import defaultSettings from '@/ui/ui_favorites/default-settings.json';

/**
* @class
* @private
*
* @description
* DOM + Favorites
*/
var FavoritesDOM = function() {
  var self = this;

  document.addEventListener('DOMContentLoaded', function(event) {
    self._init();
  });
};

/**
* Инициализация
* @method
* @private
*/
FavoritesDOM.prototype._init = function() {
  var self = this;
  self.products = [];
  self.options = options;
  self.defaultSettings = defaultSettings;
  self._bindAddItem();
  self._bindDeleteItem();
  self._bindClearFavorites();
  self._bindTrigger();

  EventBus.subscribe('update_items:insales:favorites_products', function(data) {
    self.products = data.products || [];
    jquery(self.options.counter.attr).html(self.products.length);

    if (self.products.length <= 0) {
      jquery(self.options.counterBtn.attr).addClass(self.defaultSettings.classes.favoritesEmpty);
      jquery(self.options.counter.attr).addClass(self.defaultSettings.classes.favoritesEmpty);
    } else {
      jquery(self.options.counterBtn.attr).removeClass(self.defaultSettings.classes.favoritesEmpty);
      jquery(self.options.counter.attr).removeClass(self.defaultSettings.classes.favoritesEmpty);
    }
  });
};

/**
* Обработчик добавления
* @method
* @private
*
* @listens always:insales:favorites_products
*/
FavoritesDOM.prototype._bindAddItem = function() {
  var self = this;

  jquery(document).on('click', self.options.add.attr, function(event) {
    event.preventDefault();
    var $button = jquery(this); // eslint-disable-line vars-on-top

    if (!$button.prop(self.options.inProcess.value)) {
      $button.prop(self.options.inProcess.value, true);
      self._addItem($button);
    }
  });

  EventBus.subscribe('always:insales:favorites_products', function(eventData) {
    var try_added = (eventData.method == 'add_item' || eventData.method == 'overload');
    if (eventData.button && try_added) {
      eventData.button.prop(self.options.inProcess.value, false);
    }
  });
};

/**
* Обработчик триггера
* @method
* @private
*
*/
FavoritesDOM.prototype._bindTrigger = function() {
  var self = this;

  EventBus.subscribe('update_items:insales:favorites_products', function(data) {
    self.products = data.products || [];

    jquery(self.options.trigger.attr).each(function() {
      var $button = jquery(this);
      var id = $button.attr(self.options.trigger.value);
      var check = self._checkFavorites(id);

      toggleClass(check, $button);
      toggleText(check, $button);
    });
  });

  jquery(document).on('click', self.options.trigger.attr, function(event) {
    event.preventDefault();
    var $button = jquery(this); // eslint-disable-line vars-on-top
    var id = $button.attr(self.options.trigger.value);
    var check = self._checkFavorites(id);

    if (check) {
      toggleClass(check, $button);
      toggleText(check, $button);
      self._deleteItem($button);
    } else {
      toggleClass(check, $button);
      toggleText(check, $button);
      self._addItem($button);
    }
  });

  function toggleText(check, $button) {
    var textNotAdded = jquery($button).find(self.options.triggerNotAddedText.attr);
    var textNotAddedIn = textNotAdded.attr(self.options.triggerNotAddedText.value);
    var textAdded = jquery($button).find(self.options.triggerAddedText.attr);
    var textAddedIn = textAdded.attr(self.options.triggerAddedText.value);

    if (check) {
      textAdded.html(textAddedIn);
    } else {
      textNotAdded.html(textNotAddedIn);
    }
  }

  function toggleClass(check, $button) {
    if (check) {
      jquery($button)
        .removeClass(self.defaultSettings.classes.favoritesNotAdded)
        .addClass(self.defaultSettings.classes.favoritesAdded);
    } else {
      jquery($button)
        .removeClass(self.defaultSettings.classes.favoritesAdded)
        .addClass(self.defaultSettings.classes.favoritesNotAdded);

      if (self.products.length == 20) {
        jquery($button).addClass(self.defaultSettings.classes.favoritesLimit);
      } else {
        jquery($button).removeClass(self.defaultSettings.classes.favoritesLimit);
      }
    }
  }
};

/**
* Добавлен ли уже товар в избранное
* @method
* @private
*
*/
FavoritesDOM.prototype._checkFavorites = function(id) {
  var self = this;
  var productId = _toNumber(id);
  var ids = _map(self.products, 'id');

  return _includes(ids, productId);
};

/**
* Обработчик очистки
* @method
* @private
*
* @listens always:insales:favorites_products
*/
FavoritesDOM.prototype._bindClearFavorites = function() {
  var self = this;

  jquery(document).on('click', self.options.clear.attr, function(event) {
    event.preventDefault();
    var $button = jquery(this); // eslint-disable-line vars-on-top

    if (!$button.prop(self.options.inProcess.value)) {
      $button.prop(self.options.inProcess.value, true);
      self._clearFavorites($button);
    }
  });

  EventBus.subscribe('always:insales:favorites_products', function(eventData) {
    var try_clear = (eventData.method == 'clear' || eventData.method == 'overload');

    if (eventData.button && try_clear) {
      eventData.button.prop(self.options.inProcess.value, false);
    }
  });
};

/**
* Основаня логика добавления товара в избранное по кнопке
* @method
* @private
*
* @param {Object} $button - jQuery-нода кнопки
*/
FavoritesDOM.prototype._addItem = function($button) {
  var self = this;
  if ($button.attr(self.options.add.value)) {
    var bind = self.options.add.value;
  } else {
    var bind = self.options.trigger.value;
  }
  var task = {
    button: $button,
    item: parseInt($button.attr(bind))
  };

  FavoritesProducts.add(task);

  return;
};

/**
* Обработчик удаления
* @method
* @private
*
* @listens always:insales:favorites_products
*/
FavoritesDOM.prototype._bindDeleteItem = function() {
  var self = this;

  jquery(document).on('click', self.options.delete.attr, function(event) {
    event.preventDefault();
    var $button = jquery(this); // eslint-disable-line vars-on-top

    if (!$button.prop(self.options.inProcess.value)) {
      $button.prop(self.options.inProcess.value, true);
      self._deleteItem($button);
    }
  });

  EventBus.subscribe('always:insales:favorites_products', function(eventData) {
    if (eventData.button && eventData.method == 'remove_item') {
      eventData.button.prop(self.options.inProcess.value, false);
    }
  });
};

/**
* Основаня логика удаления товара из избранного по кнопке
* @method
* @private
*
* @param {Object} $button - jQuery-нода кнопки
*/
FavoritesDOM.prototype._deleteItem = function($button) {
  var self = this;

  if ($button.attr(self.options.delete.value)) {
    var bind = self.options.delete.value;
  } else {
    var bind = self.options.trigger.value;
  }

  var task = {
    button: $button,
    item: parseInt($button.attr(bind))
  };

  FavoritesProducts.remove(task);
};

/**
* Очистка избранного по кнопке
* @method
* @private
*
* @param {Object} $button - jQuery-нода кнопки
*/
FavoritesDOM.prototype._clearFavorites = function($button) {
  var self = this;
  var task = {
    button: $button,
    item: parseInt($button.attr(self.options.clear))
  };

  FavoritesProducts.clear(task);
};

/**
* @private
*
* @description
* Получение текста из словаря базовых сообщений
*/
FavoritesDOM.prototype._getMessageByLocale = function(messageName) {
  var self = this;

  if (typeof self.locale !== 'undefined') {
    var result_message = self.defaultSettings[messageName][self.locale];

    if (typeof result_message === 'undefined') {
      result_message = self.defaultSettings[messageName].ru;
    }

    return result_message;
  }

  return self.defaultSettings[messageName].ru;
};

export default _Singleton(FavoritesDOM).getInstance();
